import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: string;
  onBack?: () => void;
}

export function PageHeader({ title, subtitle, actions, className, onBack }: PageHeaderProps): JSX.Element {
  const containerClasses = ['page-header', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClasses}>
      <div className="page-header__titles">
        <div className="page-header__title-row">
          {onBack ? (
            <button type="button" onClick={onBack} className="button button-secondary">
              Back
            </button>
          ) : null}
          <h1 className="page-header__title">{title}</h1>
        </div>
        {subtitle ? <p className="page-header__subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="page-header__actions">{actions}</div> : null}
    </div>
  );
}
